<button pButton class="icon-action" icon="fa fa-info-circle" pTooltip="CLIN Detail" tooltipPosition="top"
        (click)="onClickShowClinInfo(op, $event)">
</button>

<p-overlayPanel #op [dismissable]="true" [showCloseIcon]="true">
  <ng-template pTemplate>
    <table class="table table-striped" style="width: 100%">
      <tbody>
      <tr>
        <td> Name</td>
        <td> {{clinInfo?.name}} </td>
      </tr>
      <tr>
        <td> Type</td>
        <td> {{clinInfo?.clinType}} </td>
      </tr>
      <tr>
        <td> Number</td>
        <td> {{clinInfo?.clinNumber}} </td>
      </tr>
      <tr>
        <td> Billing Type</td>
        <td> {{clinInfo?.billingType | titleCase}} </td>
      </tr>
      <tr>
        <td> Rev Rec Type</td>
        <td> {{clinInfo?.revenueRecognitionType | titleCase}} </td>
      </tr>
      <tr>
        <td> Total Labor</td>
        <td> {{clinInfo?.totalLaborAmount | currency: Format.Currency}} </td>
      </tr>
      <tr>
        <td> Total Travel</td>
        <td> {{clinInfo?.totalTravelAmount  | currency: Format.Currency}} </td>
      </tr>
      <tr>
        <td> Total Expense</td>
        <td> {{clinInfo?.totalExpenseAmount  | currency: Format.Currency}} </td>
      </tr>
      <tr>
        <td> Billing %</td>
        <td> {{clinInfo?.billingPercent}} %</td>
      </tr>
      </tbody>
    </table>
  </ng-template>
</p-overlayPanel>
